import { createContext } from "react";
import {
  ClientData,
  ClientsMetadataManager,
  ClientStatus,
  QueryStatus,
} from "@shared/types";

export const ClientsDataContext = createContext<
  ClientsMetadataManager | undefined
>(undefined);
